import { RouteTypes } from '../../consts';
import { FechaMaximaPractica } from './types';

export const getCurrentListNameToCount = () => {
  switch (window.location.pathname) {
    case `${RouteTypes.AUDIT}`:
      return 'practicasAuditoriaCount';
    case `${RouteTypes.HOME}`:
      return 'practicasCount';
    default:
      return '';
  }
};

export const getMessageFromResponse = (message?: string) => {
  return message !== undefined && message !== null && message !== ''
    ? `${message}.`
    : '';
};

export const getDefaultFechaMaximaPractica = () => {
  const todayEnd = new Date();
  todayEnd.setHours(23, 59, 59, 999);
  const fechaMaximaPractica: FechaMaximaPractica = {
    FECHA_DATE: `${todayEnd.getDate()}-${
      todayEnd.getMonth() + 1
    }-${todayEnd.getFullYear()}`,
    FECHA_TIMESTAMP: todayEnd.getTime(),
  };
  return fechaMaximaPractica;
};
